// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38Fkm","content":"styles_content__yUrRx"};